import { createTypedField, DotNetType } from 'tessa/platform';
import { CardRequest, CardService } from 'tessa/cards/service';
import { CdRequestTypes } from 'src/cdScripts/Helpers/CdRequestTypes';
import { userSession } from 'common/utility';
import { PkCardTypes } from '../Helpers/PkCardTypes';

export class PkMatrixWorkplaceHelper {

    public static async CheckUserInRoleAsync(roleID: string | null) : Promise<boolean> {
      const requestIsUserInRole = new CardRequest();
      requestIsUserInRole.requestType = CdRequestTypes.CheckUserInRole;
      requestIsUserInRole.info["UserID"] = createTypedField(userSession.UserID, DotNetType.Guid);
      requestIsUserInRole.info["RoleID"] = createTypedField(roleID, DotNetType.Guid);

      const responseIsUserInRole = await CardService.instance.request(requestIsUserInRole);

      if (!responseIsUserInRole.validationResult.isSuccessful)
      {
          return false;
      }

      let isUserInRole = responseIsUserInRole.info.IsUserInRole.$value as boolean;

      if (!isUserInRole)
      {          
          return false;
      }
      return true;
    }

    public static GetCardTypeByAlias(alias : string | undefined) : string | null
    {
        switch (alias)
        {
            case "PkMatrixLawyer":
                {
                    return PkCardTypes.PkMatrixLawyerTypeID;
                }

            case "PkMatrixRemark":
                {
                    return PkCardTypes.PkMatrixRemarkTypeID;
                }

            case "PkMatrixAccountant":
                {
                    return PkCardTypes.PkMatrixAccountantTypeID;
                }

            case "PkMatrixAccountantOHR":
                {
                    return PkCardTypes.PkMatrixAccountantOHRTypeID;
                }

            case "PkMatrixEditorHistoricalDocuments":
                {
                    return PkCardTypes.PkMatrixEditorHistoricalDocumentsTypeID;
                }

            case "PkMatrixConsolidating":
                {
                    return PkCardTypes.PkMatrixConsolidatingTypeID;
                }
                
            case "PkMatrixLandAssetCompanies":
                {
                    return PkCardTypes.PkMatrixLandAssetCompaniesTypeID;
                }                
            case "PkCreatorsContractsTechnicalCategory":
                {
                    return PkCardTypes.PkCreatorsContractsTechnicalCategoryTypeID;
                }

            default: return null;
        }
    }

    public static GetColumnNameByAlias(alias : string | undefined) : string | null
    {
        switch (alias)
        {
            case "PkMatrixLawyer":
                {
                    return "MatrixLawyerID";
                }

            case "PkMatrixRemark":
                {
                    return "MatrixRemarkID";
                }

            case "PkMatrixAccountant":
                {
                    return "MatrixAccountantID";
                }

            case "PkMatrixAccountantOHR":
                {
                    return "MatrixAccountantOHRID";
                }

            case "PkMatrixEditorHistoricalDocuments":
                {
                    return "PkMatrixEditorHistoricalDocumentsID";
                }

            case "PkMatrixConsolidating":
                {
                    return "MatrixConsolidatingID";
                }

            case "PkCreatorsContractsTechnicalCategory":
                {
                    return "PkCreatorsContractsTechnicalCategoryID";
                }

            default: return null;
        }
    }

    public static GetRoleIDByAlias(alias : string | undefined) : string | null
    {
        switch (alias)
        {
            case "PkMatrixLawyer":
                {
                    return "209b7107-2565-4b37-8570-3c50ec6beafa";
                }

            case "PkMatrixRemark":
                {
                    return "070ca508-0b01-48f7-ab18-896ad2f9b9fd";
                }

            case "PkMatrixAccountant":
            case "PkMatrixAccountantOHR":
                {
                    return "f73c3091-56f9-41b5-b7e8-54cccb0a3f6f";
                }

            case "PkMatrixEditorHistoricalDocuments":
                {
                    return "58836ab1-f234-4519-bb60-37fde8dbfbef";
                }

            case "PkMatrixConsolidating":
                {
                    return "e49092a0-1a18-4363-87fc-6b95cb321414";
                }
            
            case "PkMatrixLandAssetCompanies":
                {
                    return "c7a32bf4-add6-4042-850d-2dadf4dec37f";
                }
            case "PkCreatorsContractsTechnicalCategory":
            {
                return "c90df157-16d4-4124-ad2a-5c8f2904e4f5";
            }

            default: return null;
        }
    }
}